import { render, staticRenderFns } from "./CreaFatturazione.vue?vue&type=template&id=6dc601e5"
import script from "./CreaFatturazione.vue?vue&type=script&lang=js"
export * from "./CreaFatturazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports